var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m495.484 90.839h-231.226l-255.258 176.661v146.833h486.484l16.516-9.688v-30.673l-10.75-10.222v-29l10.75-7.967v-47.189l-9.667-9.261v-29.667l9.667-8.262v-47.188l-9.667-8.549v-26l9.667-12.639v-30.673c0-9.122-7.395-16.516-16.516-16.516z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.333 138.028h255.667v47.189h-255.667z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 232.405 8.258 47.189h247.742v-47.189z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 355.097v-84.097l-16.516 8.594v47.189l7 5.967v31l-7 10.222v30.673c0 9.122 7.395 16.516 16.516 16.516h478.968c9.121 0 16.516-7.395 16.516-16.516h-445.935c-27.365 0-49.549-22.183-49.549-49.548z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.258 90.839h-247.742l-10.516 16.516 10.516 172.239h247.742z",
    fill: "#5055a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 90.839c-9.121 0-16.516 7.394-16.516 16.516v172.239h16.516z",
    fill: "#3f3f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.113 127.657c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.113 193.722c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.113 259.786c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.113 160.69c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.56-3.695 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.113 226.754c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.306 127.657c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.306 193.722c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.306 259.786c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.306 160.69c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.306 226.754c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.661 127.657c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.661 193.722c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.661 259.786c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.661 160.69c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.56-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.661 226.754c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.887 144.173c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.561-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.887 210.238c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.887 177.206c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.887 243.27c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.21 127.657c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.21 193.722c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.21 259.786c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.21 160.69c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.56-3.695 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.21 226.754c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.695 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.435 144.173c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258 0 4.561-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.435 210.238c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.435 177.206c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.435 243.27c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 127.657c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 193.722c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 259.786c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 160.69c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.56-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 226.754c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.903 144.173c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.561-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.903 210.238c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.903 177.206c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.903 243.27c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.532 144.173c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.561-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.532 210.238c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.532 177.206c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.532 243.27c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.259 8.258z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 360.333 17.26 13.639h491.74v-47.189h-495.484z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 326.783v47.189h20.26c-2.401-5.82-3.743-12.189-3.743-18.876v-28.314h-16.517z",
    fill: "#e1e1e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.4ea3d82d.svg";
export { ForwardRef as ReactComponent };